import app from "flarum/forum/app";
import Component from "flarum/common/Component";
import Link from "flarum/common/components/Link";
import listItems from "flarum/common/helpers/listItems";
import ItemList from "flarum/common/utils/ItemList";
import icon from "flarum/common/helpers/icon";

export default class PlayerCard extends Component<{
  className: string,
  player: {
    profileurl: string,
    avatarfull: string,
    personaname: string
  },
  user: any
}> {
  view() {
    const ply = this.attrs.player;

    return (
      <div className={'UserCard ' + (this.attrs.className || '')}>
        <div className="darkenBackground">
          <div className="container">
            <div className="UserCard-profile">
              <h2 className="UserCard-identity">
                <Link href={ply.profileurl}>
                  <div className="UserCard-avatar">
                    <img src={ply.avatarfull} className="Avatar" alt={ply.personaname}/>
                  </div>
                  {ply.personaname}
                </Link>
              </h2>
              <ul className="UserCard-info">{listItems(this.infoItems().toArray())}</ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /**
   * Build an item list of tidbits of info to show on this user's profile.
   *
   * @return {ItemList}
   */
  infoItems() {
    const items = new ItemList();

    /*if (lastSeenAt) {
      items.add(
        'lastSeen',
        <span className='UserCard-lastSeen'>
          {[icon('far fa-clock'), ' ', humanTime(lastSeenAt)]}
        </span>
      );
    }

    items.add('joined', app.translator.trans('rhodes-island.forum.player.joined_date_text', { ago: humanTime() }));*/

    items.add("steam", <a href={this.attrs.player.profileurl}>
      {[icon("fab fa-steam"), " ", app.translator.trans("rhodes-island.forum.player.to_steam")]}
    </a>)

    if (this.attrs.user) {
      items.add("user", <a href={this.attrs.user.url}>
        {[icon("fas fa-id-card"), " ", app.translator.trans("rhodes-island.forum.player.to_user")]}
      </a>)
    }

    return items;
  }
}
